<template>
  <Loader v-if="loading" />
  <div v-else>
    <BaseFormGroup>
      <BaseFormLabel :for="`${_uid}-tags`"> Tags </BaseFormLabel>

      <ul class="space-y-8">
        <li v-for="group in options" :key="group.id" class="space-y-2">
          <h2 class="text-sm font-medium text-gray-500">
            {{ group.label }}
          </h2>
          <div class="-mx-1">
            <BaseChipsBasic v-model="data.tags" :options="group.options" multiple />
          </div>
        </li>
      </ul>
    </BaseFormGroup>
  </div>
</template>

<script>
import { accountTagCategoriesClient, projectsClient } from '@/api/clients';

export default {
  props: {
    accountUuid: { type: String, required: true },
    projectUuid: { type: String, required: true },
    defaultData: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      loading: false,
      options: [],
      data: {
        tags: [],
        ...this.defaultData,
      },
      client: null,
    };
  },

  watch: {
    'data.tags': {
      handler(tags) {
        this.$emit('update-props', tags.length ? { tags } : null);
      },
    },
  },

  created() {
    this.init();
  },

  methods: {
    async init() {
      this.loading = true;

      try {
        await this.fetchProjectClient();
        await this.fetchTagCategories();
      } catch (error) {
        //
      } finally {
        this.loading = false;
      }
    },
    async fetchProjectClient() {
      try {
        const response = await projectsClient.read(this.projectUuid, {
          params: {
            include: 'client',
          },
        });

        this.client = response.data?.data?.client || null;

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async fetchTagCategories() {
      try {
        const response = await accountTagCategoriesClient.list(this.client.id, {
          filter: {
            taggable_by: 'contact_requests',
          },
          include: 'tags',
          page_size: 500,
        });

        this.options = (response?.data || []).map((category) => ({
          id: category.id,
          label: category.name,
          options: category.tags.map((tag) => ({ value: tag.id, label: tag.name })),
        }));

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
